import React, { useEffect, useState } from "react";

/**
 * Este hook permite mostrar u coultar el chatbot de zoho.
 */
export const useChat = () => {
    const [visible, setVisible] = useState(false);

    const show = () => {
        document.body.querySelectorAll('.zsiq_floatmain').forEach(element=>{
            element.setAttribute('style', 'display:block !important;');
        })
        document.body.querySelectorAll('.zls-sptwndw').forEach(element=>{
            element.setAttribute('style', 'visibility:visible !important;');
        })
    }

    const hide = () => {
        document.body.querySelectorAll('.zsiq_floatmain').forEach(element=>{
            element.setAttribute('style', 'display:none !important;');
        })
        document.body.querySelectorAll('.zls-sptwndw').forEach(element=>{
            element.setAttribute('style', 'visibility:hidden !important;');
        })
    }

    useEffect(() => {
        let showInterval = null;
        let hideInterval = null;
        let cancelShowInterval = null;
        let cancelHideInterval = null;

        if (visible) {
            clearInterval(hideInterval);
            showInterval = setInterval(() => {
                show();
            }, 100);
            cancelShowInterval = setTimeout(() => {
                clearInterval(showInterval);
            }, 20*1000);
        } else {
            clearInterval(showInterval);
            hideInterval = setInterval(() => {
                hide();
            }, 100);
            cancelHideInterval = setTimeout(() => {
                clearInterval(hideInterval);
            }, 20*1000);

        }
        return () => {
            clearInterval(showInterval);
            clearInterval(hideInterval);
            clearTimeout(cancelShowInterval);
            clearTimeout(cancelHideInterval);
        }
    }, [visible])

    return {
        setVisible,
        visible
    }
}